export default "__VITE_ASSET__BporJUyr__"